module.exports = __webpack_public_path__ + "assets/media/leo-strupczewski-light.1b0f3eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/TreeringTestimonial/leo-strupczewski-light.svg
// module id = 2032
// module chunks = 0